export default __webpack_public_path__ + "static/on-demand-design-support-87822943b8b5882c9e81c1c4b6d1e5f8.pdf";